









































import { Component, Prop, Vue } from "vue-property-decorator";
import settings from "@/config/tv/settings.json";

interface ISettingJSON {
  instant_power: IModeType;
  display_resolution: IModeType;
  boot_sequence_option: IModeType;
  application_channel_control: IModeType;
  tv_channel_ui: IModeType;
  tv_volume_ui: IModeType;
  tv_caption_ui: IModeType;
  tv_channel_attribute_floating_ui: IModeType;
  channel_lock: IModeType;
  key_delivery_to_simplink: IModeType;
  wol_w: IModeType;
  wol_m: IModeType;
  inband_data_service_mhp: IModeType;
  inband_data_service_mheg: IModeType;
  inband_data_service_hbbtv: IModeType;
  security_level: IModeType;
  wifi_screen_share: IModeType;
  smart_share: IModeType;
  smart_pairing: IModeType;
  dmr: IModeType;
  browser_https_security_level: IModeType;
  pcr_recovery: IModeType;
  mute_on_tv_input: IModeType;
  soft_ap_ui: IModeType;
  soft_ap: IModeType;
  rs232c: IModeType;
  https_xait_xml: IModeType;
  block_external_input: IModeType;
  block_ir: IModeType;
  block_local_key: IModeType;
  block_usb: IModeType;
  block_hidden_menu: IModeType;
  block_launcher: IModeType;
  block_hotkey: IModeType;
  clock_display: IModeType;
  teletext: IModeType;
  secure_mmr_pairing: IModeType;
  dial: IModeType;
  alljoyn: IModeType;
  clock_source: IModeType;
}

interface IModeType {
  key: string;
  description: string;
  value_format: Array<{ code: string; value: string }>;
  read_write: { read: boolean; write: boolean };
  example: string;
}

interface ICommand {
  key: string;
  value: string;
  updatetime: string; //default: now
  date: Date;
  manager_id: string;
}

@Component({})
export default class DdCommand extends Vue {
  @Prop({ type: String, default: "command" }) type!: string;
  @Prop({ type: Array, default: () => [] }) tvs!: Array<string>;

  s: ISettingJSON = settings;
  value_format = "";

  get mode(): IModeType | null {
    if (this.type == "instant_power") return this.s.instant_power;
    if (this.type == "display_resolution") return this.s.display_resolution;
    if (this.type == "boot_sequence_option") return this.s.boot_sequence_option;
    if (this.type == "application_channel_control")
      return this.s.application_channel_control;
    if (this.type == "tv_channel_ui") return this.s.tv_channel_ui;
    if (this.type == "tv_volume_ui") return this.s.tv_volume_ui;
    if (this.type == "tv_caption_ui") return this.s.tv_caption_ui;
    if (this.type == "tv_channel_attribute_floating_ui")
      return this.s.tv_channel_attribute_floating_ui;
    if (this.type == "channel_lock") return this.s.channel_lock;
    if (this.type == "key_delivery_to_simplink")
      return this.s.key_delivery_to_simplink;
    if (this.type == "wol_w") return this.s.wol_w;
    if (this.type == "wol_m") return this.s.wol_m;
    if (this.type == "inband_data_service_mhp")
      return this.s.inband_data_service_mhp;
    if (this.type == "inband_data_service_mheg")
      return this.s.inband_data_service_mheg;
    if (this.type == "inband_data_service_hbbtv")
      return this.s.inband_data_service_hbbtv;
    if (this.type == "security_level") return this.s.security_level;
    if (this.type == "wifi_screen_share") return this.s.wifi_screen_share;
    if (this.type == "smart_share") return this.s.smart_share;
    if (this.type == "smart_pairing") return this.s.smart_pairing;
    if (this.type == "dmr") return this.s.dmr;
    if (this.type == "browser_https_security_level")
      return this.s.browser_https_security_level;
    if (this.type == "pcr_recovery") return this.s.pcr_recovery;
    if (this.type == "mute_on_tv_input") return this.s.mute_on_tv_input;
    if (this.type == "soft_ap_ui") return this.s.soft_ap_ui;
    if (this.type == "soft_ap") return this.s.soft_ap;
    if (this.type == "rs232c") return this.s.rs232c;
    if (this.type == "https_xait_xml") return this.s.https_xait_xml;
    if (this.type == "block_external_input") return this.s.block_external_input;
    if (this.type == "block_ir") return this.s.block_ir;
    if (this.type == "block_local_key") return this.s.block_local_key;
    if (this.type == "block_usb") return this.s.block_usb;
    if (this.type == "block_hidden_menu") return this.s.block_hidden_menu;
    if (this.type == "block_launcher") return this.s.block_launcher;
    if (this.type == "block_hotkey") return this.s.block_hotkey;
    if (this.type == "clock_display") return this.s.clock_display;
    if (this.type == "teletext") return this.s.teletext;
    if (this.type == "secure_mmr_pairing") return this.s.secure_mmr_pairing;
    if (this.type == "dial") return this.s.dial;
    if (this.type == "alljoyn") return this.s.alljoyn;
    if (this.type == "clock_source") return this.s.clock_source;
    return null;
  }

  onSuccess(): void {
    if (!this.mode || !this.value_format || !this.tvs.length) return;
    const command: ICommand = {
      key: this.mode.key,
      value: `${this.value_format}`,
      updatetime: "now",
      date: new Date(),
      manager_id: "",
    };
    this.value_format = "";
    this.$emit("sendComands", command);
  }
}
